<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">
  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Caritate</h1>

  <div class="row align-items-center pt-xl-2 mb-lg-2 mb-xl-3 mb-xxl-4">
    <div class="col-md-7 col-lg-6 mb-4 mb-md-0">
      <div class="d-block position-relative">
        <div class="bg-faded-primary rounded-5 position-absolute top-0 start-0 w-100 h-100" data-aos="zoom-in"
          data-aos-duration="600" data-aos-offset="250"></div>

        <svg-icon src="assets/images/illustrations/charity.svg" class="d-block position-relative zindex-2 ms-auto p-2"
          data-aos="fade-in" data-aos-duration="400" data-aos-offset="250"></svg-icon>

      </div>
    </div>
    <div class="col-md-5 col-xl-4 offset-lg-1" data-aos="fade-up" data-aos-duration="400" data-aos-offset="170">
      <div class="ps-md-3 ps-lg-0">
        <h2 class="h1 pb-md-2 pb-xl-3">Evenimente caritabile</h2>
        <div class="pb-3 mb-3 mb-lg-4">
          <p>GiftShare pune la dispozitie platforma gratuit pentru cei ce aleg sa fie responsabili social si sa
            se implice activ in comunitate pentru a crea o lume mai buna!</p>
          <p>Poti strange fonduri pentru proiectele ONG-urilor care aduc schimbare in comunitate sau poti inscrie
            chiar tu un proiect in care crezi si pentru care vrei sa creezi o campanie de strangere de fonduri.
            Poti chiar sa-ti transformi momentul tau special intr-o oportunitate sa faci bine in societate:
            in loc de cadouri, spune familiei si prietenilor sa doneze pentru cauza sociala pe care vrei
            sa o sustii.</p>
          <a [routerLink]="(isCorporateUser$ | async) ? ['/corporate/creare-campanie'] : ['/user/creare-eveniment']"
            [queryParams]="{eventTypeId: 80}" class="btn btn-lg btn-primary rounded-pill mt-2">Creeaza eveniment</a>
        </div>
      </div>

    </div>
  </div>
</section>


<section class="container py-5 my-2 my-lg-3 my-xl-4 my-xxl-5 text-center">
  <h2 class="h1">Parteneri caritate</h2>
  <p class="pb-1 pb-sm-2 pb-md-3 pb-lg-4 mb-3">Poti dona catre unul dintre ONG-urile de mai jos.</p>

  <gs-partner-list [filterInCategories]="[charityCategoryId]"></gs-partner-list>

</section>
